import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const FolderIcon: React.FC<IProps> = props => {
	const { className, fillColor, ...restProps } = props;
	return (
		<SvgIcon className={`folder-icon ${className || ''}`} height={14} width={16} {...restProps}>
			<path
				fill={fillColor ?? 'currentColor'}
				d='M14.5 3H8L6.5 1.5C6.1 1.1 5.55 1 5 1H1.5C0.67 1 0 1.67 0 2.5V11.5C0 12.33 0.67 13 1.5 13H14.5C15.33 13 16 12.33 16 11.5V4.5C16 3.67 15.33 3 14.5 3ZM14.5 11.5H1.5V4.5H14.5V11.5ZM1.5 2.5H5L6 3.5H1.5V2.5Z'
			/>
		</SvgIcon>
	);
};
